import React, { Component } from "react";
import { apiFetch, clearIdempotencyKey } from "../../utils";

class PayPalButton extends Component {
    constructor(props) {
        super(props);
        this.paypalRef = React.createRef();
    }

    componentDidMount() {
        this.loadPayPalScript();
    }

    componentDidUpdate(prevProps) {
        // Re-render button if amount or currency changes
        if (
            prevProps.amount !== this.props.amount ||
            prevProps.currency !== this.props.currency
        ) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.renderButton();
            }, 100);
        }
    }

    loadPayPalScript = () => {
        if (!window.paypal) {
            // Only append script once
            if (!document.getElementById("paypal-sdk")) {
                const script = document.createElement("script");
                script.id = "paypal-sdk";
                script.src = `https://www.paypal.com/sdk/js?client-id=AZtd4cF6kb_Q-aT5Yq__uffPxtNKK4YJNjsNf3FD2oG3w0ydMaHiFgy3A1JQf715IZGtgHvMhtl1zzSu&currency=${this.props.currency || "USD"}`;
                script.onload = this.renderButton;
                document.body.appendChild(script);
            }
        } else {
            this.renderButton();
        }
    };

    renderButton = () => {
        const { amount, currency, onSuccess } = this.props;

        if (!window.paypal || !this.paypalRef.current) return;

        // Clear previous buttons before rendering new one
        this.paypalRef.current.innerHTML = "";

        window.paypal.Buttons({
            createOrder: async () => {
                try {
                    const res = await apiFetch("/api/paypal/create-order", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ amount, currency }),
                        idempotencyAction: "wallet:topup"
                    });

                    const data = await res.json();
                    return data.id;
                } catch (err) {
                    console.error("Create order failed:", err);
                    alert("❌ Failed to create PayPal order.");
                }
            },
            onApprove: async (data) => {
                try {
                    const res = await apiFetch(`/api/paypal/capture-order/${data.orderID}`, {
                        method: "POST",
                        idempotencyAction: "wallet:topup"
                    });

                    const details = await res.json();

                    // Clear idempotency key after success
                    clearIdempotencyKey("wallet:topup");

                    alert("✅ Payment successful!");
                    if (onSuccess) onSuccess(details);
                } catch (err) {
                    console.error("Capture failed:", err);
                    alert("❌ Failed to capture PayPal order.");
                }
            },
            onError: (err) => {
                console.error("PayPal error:", err);
                alert("❌ PayPal transaction failed. Please try again.");
            }
        }).render(this.paypalRef.current);
    };

    render() {
        return (
            <div>
                <h5>Pay with PayPal</h5>
                <div ref={this.paypalRef}></div>
            </div>
        );
    }
}

export default PayPalButton;
